import './Template.scss';

import React, { useState } from 'react';

import Container from 'react-bootstrap/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Navbar from 'react-bootstrap/Navbar';
import Sidebar from './Sidebar';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const NavbarTop = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div>
            <Navbar className="custom-navbar custom-navbar-top">
                <Container>
                    <FontAwesomeIcon onClick={handleShow} icon={faBars} size="lg" className='icon-menu-bottom' />
                    <Navbar.Brand>HALLAPP</Navbar.Brand>
                </Container>
            </Navbar>
            <Sidebar show={show} handleClose={handleClose}/>
        </div>
    );
};

export default NavbarTop;